import { LEXON_API_URL } from 'src/config'
import { Expedient } from 'src/interfaces/lexon'
import lexonHttp from 'src/utils/Http/LexonHttp'

const EXPEDIENT_LIST = `${LEXON_API_URL}/expedients/listExpedients`

export interface GetExpedientsResponse {
  items: Expedient[]
}

export async function getExpedients(): Promise<Expedient[]> {
  return lexonHttp.post({ url: `${EXPEDIENT_LIST}` }).then(res => res)
}
